import API from "@/models/API";
import router from "@/routes"

let storesType = () => ((router?.history.current.path||'').split('/')||[])[2] == 'storePanel' ? 'stores':'companies'
    

export default class AttributeOption {

    constructor(item = {}) {
        this.attribute_option_id = item.attribute_option_id || null;
        this.attribute_id = item.attribute_id || null;
        this.option = item.option || {
            el: "",
            en: "",
            it: ""
        };
   
    }

    
    static getAttributeOptions = (q='') =>
        API.get(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/attribute-options${q}`
        );
    
        static createAttributeOption = (body) =>
        API.post(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/attribute-options`, body
        );
    
        static updateAttributeOption = (id,body) =>
        API.put(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/attribute-options/${id}`, body
        );
    
        static deleteAttributeOption = (id) =>
        API.delete(
            `/${storesType()}/${localStorage.getItem("storeId")}/subscriptions/products/attribute-options/${id}`
        );

}
